import API, { GraphQLResult, graphqlOperation } from '@aws-amplify/api';
import * as APIt from '../API';
import { createUserAction as createUserActionMutationOp} from '../graphql/mutations';
import { debug } from './commonUtils';
import * as uuid from 'uuid';
import { UserActionNames } from 'src/constants/Constants';

export interface CreateUserActionInterface {
  username: string;
  actionName: UserActionNames;
  parameters?: string;
}
export const createUserAction = async (userAction: CreateUserActionInterface): Promise<APIt.UserAction | undefined | null> => {
  debug(`createUserAction(): userAction is ${JSON.stringify(userAction)}`);

  try {
    const createUserActionMutationReponse = await API.graphql(graphqlOperation(createUserActionMutationOp,
      {
        input: {
          actionId: uuid.v4(),
          username: userAction.username,
          actionName: userAction.actionName,
          timestamp: new Date().getTime().toString(),
          parameters: userAction.parameters
        }
      })) as GraphQLResult<APIt.CreateUserActionMutation>;
    debug(`createUserAction(): createUserActionMutationReponse is ${JSON.stringify(createUserActionMutationReponse)}`);
    return createUserActionMutationReponse?.data?.createUserAction as APIt.UserAction;
  } catch(error) {
    console.error(`createUserAction(): error is ${JSON.stringify(error)}`);
    throw error;
  }
}